import { motion } from 'framer-motion';
import React from 'react';
import { useInView } from 'react-intersection-observer';
import { SectionHeader } from '../ui/SectionHeader';
import { UniversityCarousel } from '../ui/UniversityCarousel';

export const CredibilitySection: React.FC = () => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.1
  });

  // University partners with actual logos
  const universityPartners = [
    { name: 'جامعة الملك سعود', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/7.png' },
    { name: 'جامعة الملك عبدالعزيز', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/20.png' },
    { name: 'جامعة الملك فهد للبترول والمعادن', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/24.png' },
    { name: 'جامعة الأميرة نورة', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/12.png' },
    { name: 'جامعة الامام محمد بن سعود الإسلامية', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/5.png' },
    { name: 'جامعة الملك فيصل', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/14.png' },
    { name: 'جامعة أم القرى', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/6.png' },
    { name: 'جامعة الملك خالد', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/19.png' },
    { name: 'الجامعة السعودية الإلكترونية', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/31.png' },
    { name: 'جامعة الطائف', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/8.png' },
    { name: 'جامعة جازان', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/2.png' },
    { name: 'جامعة الحدود الشمالية', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/29.png' },
    { name: 'جامعة القصيم', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/11.png' },
    { name: 'جامعة طيبة', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/13.png' },
    { name: 'جامعة شقراء', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/15.png' },
    { name: 'جامعة حفر الباطن', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/16.png' },
    { name: 'جامعة الباحة', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/17.png' },
    { name: 'جامعة نجران', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/18.png' },
    { name: 'جامعة الأمير سطام', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/21.png' },
    { name: 'جامعة بيشة', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/23.png' },
    { name: 'جامعة تبوك', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/25.png' },
    { name: 'جامعة الجوف', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/26.png' },
    { name: 'الجامعة الإسلامية', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/27.png' },
    { name: 'جامعة حائل', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/28.png' },
    { name: 'جامعة جدة', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/9.png' },
    { name: 'جامعة المجمعة', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/3.png' },
    { name: 'جامعة الامام عبدالرحمن بن فيصل', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/1.png' },
    { name: 'جامعة الملك سعود للعلوم الصحية', logoUrl: 'https://dawwalkhreej-eu.s3.eu-central-1.amazonaws.com/4.png' }
  ];



  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
        delayChildren: 0.2
      }
    }
  };

  return (
    <section className="py-20 bg-white">
      <div className="section-container">
        <SectionHeader
          subtitle="الثقة والاعتمادية"
          title="شريك موثوق للمؤسسات التعليمية"
          description="نفخر بثقة أكثر من 30 جامعة سعودية والمؤسسات التعليمية في خدماتنا المتقدمة"
        />

        {/* University Partners Grid */}
        <motion.div
          ref={ref}
          variants={containerVariants}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          className="mt-16"
        >
          <div className="text-center mb-12">
            <h3 className="text-2xl font-bold text-government-navy mb-4 font-heading">
              الجامعات الشريكة
            </h3>
            <p className="text-gray-600">
              30+ جامعة سعودية تثق في منصتنا لتوفير بيانات القبول الدقيقة والمحدثة
            </p>
          </div>

          <div className="mb-12 lg:mb-16">
            <UniversityCarousel 
              universities={universityPartners}
              autoplay={true}
              duration={6000}
            />
          </div>
        </motion.div>

       


      </div>
    </section>
  );
};